// Feature flags
// Toggle WebSockets. Default: disabled, but automatically enabled in test to satisfy WS-related specs.
const envFlag = typeof process !== 'undefined' ? process.env.REACT_APP_WS_ENABLED : undefined;
export const WS_ENABLED = (typeof process !== 'undefined' && process.env.NODE_ENV === 'test')
  || (envFlag ? envFlag === 'true' : false);


